import { render, staticRenderFns } from "./PresentationFilterBar.vue?vue&type=template&id=47acbe62"
import script from "./PresentationFilterBar.vue?vue&type=script&lang=ts"
export * from "./PresentationFilterBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports